﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailAktion extends GuiDetailGeneric {

    constructor() {
        super("Aktion");
        this.onChangeAbfallId();
    }

    attachEvents() {
        super.attachEvents();

        $("#btnAktionAddPosition").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickAktionAddPosition(e));
        $("#btnAktionAddKostenverteilung").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickAktionAddKostenverteilung(e));

        $("#VmDetail_Menge").on("keyup", () => this.onChangeMenge());

        // Bei Direktaktionen kann Einheit und Umrechnungsfaktor geändert werden
        if($("#VmDetail_IsDirektaktion").val()=="True") {
            $("#VmDetail_EinheitId").on("change", () => this.onChangeMenge());
            $("#VmDetail_UmrechnungsfaktorZuTonne").on("change", () => this.onChangeMenge());
        }

        // bei Direktaktionen kann der Abfall geändert werden
        $("#VmDetail_AbfallId").on("change", () => this.onChangeAbfallId());

        $("button.erz-btn-remove-kostenart").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickKostenartDelete(e));

        // Aval
        $("#btnCreateAvalTransaction").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
        $("#btnDeleteAvalTransaction").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
        $("#btnSendAvalTransaction").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
        $("#btnStornoAvalTransaction").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
    }

    clickKostenartDelete(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickKostenartDelete");
        e.preventDefault();
        // ID in Hidden Field übernehmen
        const aktionPositionId = $(e.currentTarget).closest("div.row.erz-list-element").data("id") as string;
        $("#mdlDeletePosition").modal("show");
        $("#mdlDeletePositionbtnDelete").on("click", (ev: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickKostenartDeleteConfirm(ev, aktionPositionId));

    }

    clickKostenartDeleteConfirm(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>, aktionPositionId: string) {
        this.log(`clickKostenartDeleteConfirm: ${aktionPositionId}`);
        $("#GuiAktion").val("DeletePosition");
        $("#AktionPositionId").val(aktionPositionId);

        if (!this.form.checkValidity()) {

            e.stopPropagation();
        } else {
            this.lock();
            // Submit form über Browser Button
        }
    }

    onChangeAbfallId() {
        this.log("onChangeAbfallId");

        const valueAbfallId = $("#VmDetail_AbfallId").val();
        const selectAktionTypeId = $("#VmDetail_AktiontypId");
        const selectAktionTypeIdOptionen = $("#VmDetail_AktiontypId Option");
        const isDirektaktion = $("#VmDetail_IsDirektaktion");

        

        if (valueAbfallId == null || valueAbfallId=="") {
            this.log("ohne Abfall")
            // kein Abfall ausgewählt
            const optionOhneAbfall = selectAktionTypeId.find('option').filter(function () {
                return $(this).text().trim() === "ohne Abfall";
            });
            optionOhneAbfall.prop('selected', true);
            selectAktionTypeId.find('option').not(optionOhneAbfall).prop('disabled', true);

            $("#lblWiegeschen").css('visibility', 'hidden');
            $("#divWiegeschein").css('visibility', 'hidden');
            $("#lblBgs").css('visibility', 'hidden');
            $("#divBgs").css('visibility', 'hidden');
            $("#rowMenge").slideUp();
            $("#rowAbfallverwertung").slideUp();
            
        } else {
            this.log("mit Abfall")

            if (String(isDirektaktion.val() ?? '').toLowerCase() !== "true") {
                return;
            }

            const optionOhneAbfall = selectAktionTypeIdOptionen.filter(function () {
                return $(this).text().trim() === "ohne Abfall";
            }) as JQuery<HTMLOptionElement>;
            this.log("optionOhneAbfall.length=" +optionOhneAbfall.length);

            // Alle Optionen wieder aktivieren und ohne Abfall deaktivieren
            selectAktionTypeIdOptionen.not(optionOhneAbfall).prop('disabled', false);
            this.log("selectAktionTypeIdOptionen.length=" + selectAktionTypeIdOptionen.length);


            //var text = $("#VmDetail_AktiontypId option:selected").text().trim();
            const selectedOption = $("#VmDetail_AktiontypId option:selected");
            const text = selectedOption.text().trim();
            if (text === "ohne Abfall") {
                // wechsel auf ande Aktion, da Aball nicht mit Option "ohne Abfall" erlaubt ist
                selectAktionTypeIdOptionen.not(optionOhneAbfall).first().prop('selected', true);
            } else {
                // Scheinbar notwendig, die option noch mal zu selektieren
                selectedOption.prop("selected", true);
            }
            selectAktionTypeId.trigger('change');

            // die option "ohne Abfall" disablen, da Abfall ausgewählt wurde
            optionOhneAbfall.prop('disabled', true);

            $("#lblWiegeschen").css('visibility', 'inherit');
            $("#divWiegeschein").css('visibility', 'inherit');
            $("#lblBgs").css('visibility', 'inherit');
            $("#divBgs").css('visibility', 'inherit');
            $("#rowMenge").removeClass("d-none").slideDown();
            $("#rowAbfallverwertung").removeClass("d-none").slideDown();
        }

    }


    clickAktionAddPosition(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickAktionAddPosition");
        this.doAction(e);
    }

    clickAktionAddKostenverteilung(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickAktionAddKostenverteilung");
        this.doAction(e);
    }

    onChangeMenge() {
        this.log("onChangeMenge");

        const txtMenge = $("#VmDetail_Menge").val() as string;
        const txtFaktor = $("#VmDetail_UmrechnungsfaktorZuTonne").val() as string;

        if (txtMenge == undefined || txtFaktor == undefined) return;

        const menge = Number(txtMenge.replace(",", "."));
        const faktor = Number(txtFaktor.replace(",", "."));


        const mengeInTonnen = menge * faktor;
        this.log(mengeInTonnen + "=" + menge + "*" + faktor);
        $("#VmDetail_MengeTonne").val(mengeInTonnen.toString().replace(".", ","));
    }
}